import apiFetch from '../apiFetch'

export default function (body, token) {
  return apiFetch({ endPoint: 'UnattendedProcess/BulkDownloadProcess', method: 'POST', body: body, token: token })
}
